import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/partials/icons.d.ts').Icon}
 */
const IconChevron = ({ className, fill = 'currentColor' }) => {
    return (
        <svg
            className={'icon-arrow' + (className ? ` ${className}` : '')}
            fill='none'
            height='6'
            viewBox='0 0 10 6'
            width='10'
            xmlns='http://www.w3.org/2000/svg'>
            <path
                d='M4.49771 5.01771C4.4084 5.01771 4.32535 5.00167 4.24854 4.96958C4.17174 4.9375 4.10125 4.88945 4.03708 4.82542L0.17396 0.962083C0.0539597 0.842083 -0.00395693 0.712084 0.000209732 0.572084C0.00451529 0.432223 0.0670153 0.301875 0.18771 0.181042C0.308543 0.0603473 0.437571 0 0.574793 0C0.712015 0 0.841043 0.0603473 0.961876 0.181042L4.50188 3.74208L8.06271 0.181042C8.17813 0.0657639 8.30583 0.0102084 8.44584 0.0143751C8.5857 0.0186806 8.71604 0.0811806 8.83688 0.201875C8.95757 0.322708 9.01792 0.451737 9.01792 0.588959C9.01792 0.726181 8.95521 0.857153 8.82979 0.981875L4.96667 4.82542C4.89695 4.88945 4.82368 4.9375 4.74688 4.96958C4.67007 5.00167 4.58701 5.01771 4.49771 5.01771Z'
                fill={fill}/>
        </svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

export default IconChevron;

